<template>
  <zul-modal
    id="card-verification-modal"
    class="is-small card-verification-modal"
    ref="modal"
    title="Validação de cartão"
  >
    <p v-if="isLoading" class="loading">{{ $t("global.loading") }}</p>
    <div v-if="step === 'CONFIRM_VALUE'">
      <div class="is-2 card-cell">
        <img
          src="https://static.zuldigital.com.br/payment-method/master@2x.png"
          class="card-cell-brand"
        />

        <small class="card-cell-number">Final 5454</small>
      </div>

      <p class="text-description">
        Confirme abaixo o valor aleatório <br />
        (menor que R$ 5,00) cobrado em {{ billedIn }}
      </p>

      <zul-input
        type="text"
        class="amount-value-input"
        label="Informe o valor"
        name="amountValue"
        key="amountValue"
        @input="currencyMask"
        @keyup.enter="() => handleConfirmValue()"
        v-model="amount.value"
      ></zul-input>

      <p class="text-description">
        Você pode consultar o valor nas últimas transações do seu cartão, seja
        na fatura online, app do banco ou central de atendimento.
      </p>

      <button
        type="button"
        @click="handleConfirmValue"
        class="button is-primary is-large validate-button"
      >
        Confirmar valor
      </button>
    </div>
    <div v-else-if="step === 'CONFIRM_CVV'">
      <div class="is-2 card-cell">
        <img
          src="https://static.zuldigital.com.br/payment-method/master@2x.png"
          class="card-cell-brand"
        />

        <small class="card-cell-number">Final 5454</small>
      </div>

      <p class="text-description">
        Informe o CVV, ele pode ser encontrado no verso do seu cartão de
        crédito.
      </p>

      <zul-input
        label="Código de segurança"
        type="tel"
        class="cvv-input"
        name="cvv"
        key="cvv"
      ></zul-input>

      <button
        type="button"
        class="button is-primary is-large validate-button"
        @click="handleConfirmCvv"
      >
        Confirmar
      </button>
    </div>
    <div v-else>
      <p class="text-description">
        Esse cartão precisa ser validado por você para processarmos seu
        pagamento de forma segura.
      </p>

      <div class="is-2 card-cell">
        <img
          src="https://static.zuldigital.com.br/payment-method/master@2x.png"
          class="card-cell-brand"
        />

        <small class="card-cell-number">Final 5454</small>
      </div>

      <p class="text-description">
        Para sua conveniência e segurança utilize cartão virtual ou pagamento em
        pix.
      </p>

      <button
        type="button"
        @click="handleValidationAction"
        class="button is-primary is-large validate-button"
      >
        Validar agora
      </button>
    </div>
  </zul-modal>
</template>

<script>
import config from "config";
import moment from "moment";
import { OrderStatuses, getBrowserInfo } from "@zuldigital/classic-adyen-3ds";

export default {
  components: {},
  data() {
    return {
      promiseResolve: undefined,
      promiseReject: undefined,
      isLoading: false,
      step: "INFO_STEP",
      securityCodeRequired: false,
      paymentMethod: undefined,
      amount: {
        value: "R$ 0,00",
      },
      securityCode: {
        value: "R$ 0,00",
      },
      billedIn: "",
    };
  },
  mounted() {
    this.billedIn = moment(new Date()).format("DD/MM");

    this.$root.$on("open-card-verification-modal", () => {
      this.$refs.modal.open();
    });

    this.$root.$on("close-card-verification-modal", () => {
      this.$refs.modal.close();
    });
  },
  destroyed() {
    this.$root.$off("open-card-verification-modal");
    this.$root.$off("close-card-verification-modal");
  },
  methods: {
    getVerificationStatus(paymentMethodId) {
      this.isLoading = true;

      return this.$http
        .get(`/user/payment/${paymentMethodId}/verification-status`)
        .finally(() => {
          this.isLoading = false;
        });
    },
    requestVerification(paymentMethodId, securityCode) {
      this.isLoading = true;
      const securityForm = new FormData();

      if (securityCode) securityForm.append("securityCode", securityCode);

      securityForm.append(
        "browserInfo",
        JSON.stringify({ ...getBrowserInfo() })
      );

      securityForm.append(
        "notificationURL",
        `${config.API_URL.replace("/v7", "")}/external/payment/3ds/challenge`
      );

      return this.$http
        .post(
          `/user/payment/${paymentMethodId}/request-verification`,
          securityForm,
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .catch(this.promiseReject)
        .finally(() => {
          this.isLoading = false;
        });
    },
    verify(paymentMethodId, verifyAmount) {
      this.isLoading = true;
      const verifyForm = new FormData();

      verifyForm.append("verifyAmount", verifyAmount);

      return this.$http
        .post(`/user/payment/${paymentMethodId}/verify`, verifyForm, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    open(paymentMethodData) {
      return new Promise((resolve, reject) => {
        this.promiseResolve = resolve;
        this.promiseReject = reject;

        this.paymentMethod = paymentMethodData;
        this.$refs.modal.open();

        this.getVerificationStatus(paymentMethodData.id).then((response) => {
          this.securityCodeRequired = response.data?.securityCodeRequired;

          if (!["REQUESTED", "UNVERIFIED"].includes(response.data.status))
            this.$refs.modal.close();
        });
      });
    },
    currencyMask(value) {
      let rawValue = value.replace(".", "").replace(",", "").replace(/\D/g, "");

      if (rawValue.length === 0) {
        rawValue = "0,00";
      }

      const formattedValue = new Intl.NumberFormat("pt-BR", {
        minimumFractionDigits: 2,
      }).format(parseFloat(rawValue) / 100);

      this.amount.value = `R$ ${formattedValue.replace("BLR", "").trim()}`;
    },
    handleValidationAction() {
      if (this.securityCodeRequired) {
        this.step = "CONFIRM_CVV";
      } else {
        this.requestVerification(this.paymentMethod?.id).then((response) => {
          if (
            [
              OrderStatuses.AUTH_FINGERPRINT,
              OrderStatuses.AUTH_CHALLENGE,
            ].includes(response.data?.order?.status)
          ) {
            ////
          } else {
            this.step = "CONFIRM_VALUE";
          }
        });
      }
    },
    handleConfirmValue() {
      this.verify(this.paymentMethod.id, this.securityCode.value);
    },
    handleConfirmCvv() {
      this.requestVerification(
        this.paymentMethod.id,
        this.securityCode.value
      ).then((response) => {
        if (response?.data?.order) {
          this.promiseResolve(response.data);
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "../assets/sass/variables";

.loading {
  background: url("../assets/loading.svg") no-repeat center center;
  background-size: 100px;
  text-align: center;
  padding: 7rem 0 0;
  font-size: $size-7;
  // opacity: 0.5;
  opacity: 1;
  margin-right: 0;

  background-color: #313131;
  position: absolute;
  height: 100%;
  width: 100%;
  left: 0;
  top: 0;
  z-index: 2;
}

.text-description {
  text-align: center;
}

.column {
  height: auto !important;
}

.card-cell {
  background-color: rgb(242, 242, 247);
  padding: 20px;
  border-radius: 10px;
  display: flex;
  gap: 14px;
  align-items: center;
  margin: 15px 0;
}

.card-cell-brand {
  width: 40px !important;
  height: auto !important;
  display: inline-flex;
}

.card-cell-number {
  font-weight: 700;
  color: #000 !important;
}

.validate-button {
  font-size: 1rem !important;
  margin: 20px auto 0;
  display: flex;
  width: 100%;
}
</style>
<style>
.card-verification-modal .modal-card-foot {
  padding: 1rem !important;
}

.card-verification-modal .modal-card-body > div:first-child {
  max-width: 450px;
  margin: 0 auto;
}

.cvv-input,
.amount-value-input {
  background-color: #313131 !important;
  margin-top: 20px;
  margin-left: auto;
  margin-right: auto;
  border-bottom: 1px solid #fff;
  width: 90%;
}

.cvv-input label,
.amount-value-input label {
  padding-left: 0 !important;
}

.cvv-input input,
.amount-value-input input {
  padding-left: 0 !important;
}
</style>
